export const PROPOSAL_EXECUTION_GRACE_PERIOD_MS = 14 * 24 * 60 * 60 * 1000; // 14 days in milliseconds

// The Graph caps `first` at 1000 entities per query
export const PROPOSAL_TOTAL_LIMIT = 1000;
